import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import zh from './zh'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.getItem('blh5:lang') || 'zh', // 设置地区
  messages: {
    en,
    zh
  }// 设置地区信息
})
export default i18n



// WEBPACK FOOTER //
// ./src/assets/locale/index.js